import React, { useEffect, useState } from 'react'
import Clarity from '@microsoft/clarity'
import { v4 as uuidv4 } from 'uuid'

import { useIsAppInitialized } from 'hooks/useApp'
import { useAuthToken, useUserData } from 'hooks/useAuth'
import { useBackendApiBase, useClarityProjectID } from 'hooks/useEnv'

const ClarityInit: React.FC = () => {
  const clarityProjectId = useClarityProjectID()

  const backendApiBase = useBackendApiBase()
  const appInitialized = useIsAppInitialized()

  const userData = useUserData()
  const authToken = useAuthToken()

  const [isIubendaConsentGiven, setIsIubendaConsentGiven] = useState<boolean>(false)

  useEffect(() => {
    const timer = setInterval(() => {
      // @ts-expect-error window might not have property
      if (window && window.isIubendaConsentGiven && !isIubendaConsentGiven) {
        setIsIubendaConsentGiven(true)
      }
    }, 500)

    return () => clearInterval(timer)
  })

  useEffect(() => {
    if (!appInitialized || !backendApiBase || !clarityProjectId || !isIubendaConsentGiven) return

    Clarity.init(clarityProjectId)

    if (userData && authToken) {
      Clarity.identify(userData.email, authToken, window.location.pathname, userData.email)
    } else {
      Clarity.identify(uuidv4())
    }
  }, [clarityProjectId, backendApiBase, appInitialized, userData, authToken, isIubendaConsentGiven])

  return null
}

export default ClarityInit
